
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Product } from "@/lib/types";

interface ProductChartsProps {
  selectedProduct: Product | undefined;
  productUsageData: { date: string; usage: number }[];
  stockLevelHistory: { date: string; stock: number }[];
}

const ProductCharts = ({ selectedProduct, productUsageData, stockLevelHistory }: ProductChartsProps) => {
  if (!selectedProduct) return null;

  return (
    <div className="grid grid-cols-1 gap-8 mb-8">
      <Card>
        <CardHeader>
          <CardTitle>Usage Over Time: {selectedProduct.name}</CardTitle>
          <CardDescription>
            Daily product usage for the selected period
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={productUsageData}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line 
                  type="monotone" 
                  dataKey="usage" 
                  name={`${selectedProduct.name} Usage`}
                  stroke="#3b82f6" 
                  activeDot={{ r: 8 }} 
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Stock Level History: {selectedProduct.name}</CardTitle>
          <CardDescription>
            How stock levels have changed over time
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={stockLevelHistory}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line 
                  type="stepAfter" 
                  dataKey="stock" 
                  name="Stock Level" 
                  stroke="#22c55e" 
                  activeDot={{ r: 8 }} 
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProductCharts;
